import _typeof from "@babel/runtime/helpers/typeof";
import { tokens } from '@datacamp/waffles/tokens';
import React, { useMemo } from 'react';
import { replaceHexToString } from '../utils/unicode';
import { Label } from './Label';
import { jsx as ___EmotionJSX } from "@emotion/react";

var getFontColor = function getFontColor(type, theme) {
  switch (type) {
    case 'lock-console':
    case 'unlock-console':
    case 'script-output':
    case 'result':
    case 'output':
    case 'code':
      return theme === 'dark' ? tokens.colors.yellowDark : tokens.colors.yellowDarkText;

    case 'r-message':
    case 'r-warning':
    case 'parse-error':
    case 'r-error':
    case 'backend-error':
    case 'error':
      return theme === 'dark' ? tokens.colors.redLight : tokens.colors.redDarkText;

    default:
      return theme === 'dark' ? tokens.colors.greyMedium : tokens.colors.navy;
  }
};

var SessionOutputDisplayer = function SessionOutputDisplayer(_ref) {
  var sessionOutput = _ref.sessionOutput,
      theme = _ref.theme,
      userInput = _ref.userInput;
  var payload = useMemo(function () {
    // TODO: session output definition in mux should be updated to include more output types
    if (sessionOutput.type === 'script-output') {
      var _sessionOutput$payloa = sessionOutput.payload,
          output = _sessionOutput$payloa.output,
          scriptName = _sessionOutput$payloa.script_name;
      var lines = replaceHexToString(output).split('\n');
      return "\n<".concat(scriptName, "> output:").concat(lines.map(function (line) {
        return "\n    ".concat(line);
      }).join(''), "\n");
    }

    if (_typeof(sessionOutput.payload) === 'object') {
      return JSON.stringify(replaceHexToString(sessionOutput.payload));
    }

    return replaceHexToString(sessionOutput.payload);
  }, [sessionOutput]);
  return ___EmotionJSX("div", {
    style: {
      alignItems: 'baseline',
      display: 'flex'
    }
  }, sessionOutput.type === 'result' && (userInput === null || userInput === void 0 ? void 0 : userInput.outputLabel) && ___EmotionJSX(Label, {
    theme: theme
  }, userInput.outputLabel), ___EmotionJSX("div", {
    style: {
      color: getFontColor(sessionOutput.type, theme),
      marginBottom: 22,
      whiteSpace: 'pre'
    }
  }, payload));
};

export { SessionOutputDisplayer };